
import {
    apiAiConfigList, apiAiMenuList, apiAiActionLists, apiAiEngineList, apiAiActionForm, apiAiActionAdd, apiAiActionEdit, apiAiActionDetail, apiAiActionDel, apiAiActionSort, apiAiActionStatus
} from '@/api/setting'
import { Component, Prop, Vue } from 'vue-property-decorator'
import LsPagination from '@/components/ls-pagination.vue'
import { RequestPaging } from '@/utils/util'
import LsDialog from '@/components/ls-dialog.vue'
import LsForm from "@/components/ls-form.vue";
import MaterialSelect from "@/components/material-select/index.vue";
import PromotCommon from "@/components/promot-common.vue";

@Component({
    components: {
        LsDialog,
        LsPagination,
        LsForm,
        MaterialSelect,
        PromotCommon
    }
})
export default class AiActionList extends Vue {
    // 分页
    pager: RequestPaging = new RequestPaging();
    apiAiActionLists = apiAiActionLists
    searchObj: any = {
        zh_cn_title: "",
    };
    mode = 'add'
    configList: any = []
    dataForm: any = {}
    paramsForm: any = {}
    engList: any = []
    actionForm: any = []
    model_id = null
    formVisible = false
    menuList: any = []
    ai: any = {}
    linkUrl: any = {
        'qwen': 'https://help.aliyun.com/zh/model-studio/model-pricing?spm=a2c4g.11186623.0.0.7415556bsBpPqx#d67f022098nvl',
        'huoshan': 'https://console.volcengine.com/ai/overview'

    }
    // 获取列表
    getList() {
        this.pager.request({
            callback: apiAiActionLists,
            params: this.searchObj
        })
    }

    handleAdd() {
        this.dataForm = {
            ai_id: "",
            show_type: 1,// 1= 全部显示, 2= 指定id显示, 3= 指定id隐藏
            sort: 1,
            status: 1,
        };
        this.model_id = null
        this.mode = "add";
        this.formVisible = true;
    }

    getEngineList(id: number) {
        return this.configList.find((item: any) => item.id == id)?.zh_cn_title
    }

    async handleEdit(row: any) {
        let res = await apiAiActionDetail({ id: row.id })
        for (let item of res.params) {
            if (item.type == 'number') {
                item.default = Number(item.default)
                if (item?.attributes?.min) {
                    item.attributes.min = Number(item.attributes.min)
                }
                if (item?.attributes?.max) {
                    item.attributes.max = Number(item.attributes.max)
                }
                if (item?.attributes?.step) {
                    item.attributes.step = Number(item.attributes.step)
                }
            }
        }
        this.dataForm = res;
        delete this.dataForm.create_time
        delete this.dataForm.update_time
        delete this.dataForm.delete_time
        this.handleAiChange(row.ai_id)
        this.mode = "edit";
        this.formVisible = true;
    }


    handleAiChange(val: any) {
        let ai = this.configList.find((item: any) => item.id == val)
        this.ai = ai
        this.getAiActionForm(ai.engine)
    }



    modelChange(val: number) {
        let selectedItem = this.actionForm.find((item: any) => item.id == val)
        if (selectedItem) {
            delete selectedItem.id
            this.dataForm = { ...this.dataForm, ...selectedItem }
        }
    }

    handleSubmit() {
        let value = this.dataForm
        if (this.mode == "add") {
            apiAiActionAdd(value).then((res: any) => {
                this.$message.success("添加成功");
                this.getList();
                this.formVisible = false;
            });
        } else {
            apiAiActionEdit(value).then((res: any) => {
                this.$message.success("编辑成功");
                this.getList();
                this.formVisible = false;
            });
        }
    }

    getEngList() {
        apiAiEngineList({}).then(res => {
            this.engList = res
        })
    }
    handleDelete(id: number) {
        apiAiActionDel({ id: id }).then((res: any) => {
            this.$message.success("删除成功");
            this.getList();
        });
    }

    handleStatus(id: number, status: number) {
        apiAiActionStatus({ id: id, status: status }).then((res: any) => {
            this.$message.success("状态更新成功");
            this.getList();
        });
    }

    handleSort(id: number, sort: number) {
        apiAiActionSort({ id: id, sort: sort }).then((res: any) => {
            this.$message.success("排序更新成功");
            this.getList();
        });
    }

    getAiActionForm(engine: string) {
        return new Promise((resolve) => {
            apiAiActionForm({ engine: engine }).then((res: any) => {
                this.actionForm = res;
                this.model_id = res.find((item: any) => item.action == this.dataForm.action).id
                resolve(true)
            })
        })
    }

    getAiConfigList() {
        apiAiConfigList({ page_size: 99 }).then(res => {
            this.configList = res.lists
        })
    }

    getMenuList() {
        apiAiMenuList({ page_size: 99 }).then(res => {
            this.menuList = res.lists
        })
    }

    created() {
        this.getList()
        this.getAiConfigList()
        this.getEngList()
        this.getMenuList()
    }
}
